// src/components/layout/CookieBannerManager/CookieBannerManager.js

import React from 'react';
import { withRouter } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import CookieConsentBanner from "../../components/layout/CookieConsentBanner/CookieConsentBanner";
import { CHAT_ROUTE } from "../consts";

// Этот компонент принимает props от withRouter, но не App!
const CookieBannerManager = observer((props) => {

    // 1. Проверяем состояние куки (Берем из MobX Store или State App)
    // Так как нам нужно знать статус cookiesAccepted (из App), мы должны
    // получить его через пропс или через MobX Store, если он там хранится.
    // Предположим, что props.cookiesAccepted и props.onAccept передаются из App.
    const { location, cookiesAccepted, onAccept } = props;

    // 2. Логика проверки маршрута
    const isChatPage = location && location.pathname.startsWith(CHAT_ROUTE);

    // 3. Условие рендеринга
    if (isChatPage) {
        return null; // Не рендерим на страницах чата
    }

    // Также не рендерим, если пользователь уже согласился (логика из App.js)
    if (cookiesAccepted) {
        return null;
    }

    return (
        <CookieConsentBanner
            data-prerender-remove="true"
            onAccept={onAccept}
        />
    );
});

// Экспортируем компонент, обернутый в withRouter
export default withRouter(CookieBannerManager);